<router-outlet></router-outlet>
<xux-loader [contentLoader]="true" [isCancelButtonExist]="false"></xux-loader>
<xux-icon-defs></xux-icon-defs>
